import React from "react";
import "./styles.scss";

const CustomContentCard = ({ children, cardColor }) => {
  return <div className="content-card-container" style={{background: cardColor }}>{children}</div>;
};

export default CustomContentCard;
